<template>

    <div class="operators_radio ">
        <label v-for="(op, index) in multiOperatorInfo.multiOperatorKeys"
               :key="index"
               class="operators_radio operators_radio_inline">
          <img class="operators_icon"
               :src="getOperatorImage(index)"
               :alt="getOperatorDisplayName(index)">
          <input type="radio"
                 name="operator"
                 v-model="selectedOperator"
                 @click="onOperatorSelect(op)"
                 :value="op">
          <span></span>
        </label>

      <div class="form-group form-group--mobile form-group form-group--icon has-warning"
           v-if="error">
      <span class="form-group__feedback">
         {{ getTranslations.visitor_sign_up_1_single_country_select_operator }}
      </span>
      </div>
    </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'OperatorSelection',
  props: ['error'],
  data() {
    return {
      selectedOperator: null,
    };
  },
  created() {
    if (this.multiOperatorInfo.multiOperatorKeys.length === 1) {
      this.selectedOperator = this.multiOperatorInfo.multiOperatorKeys[0];
      this.onOperatorSelect(this.selectedOperator);
    }
  },
  methods: {
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    onOperatorSelect(operator) {
      this.$emit('choose', operator);
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/OperatorSelection.vue